import { LinkGroup } from "./LinkGroup.js";

export default LinkGroup;
